import { ApiParameter, post, request } from "@insite/client-framework/Services/ApiService";

const serviceUri = "/api/v1/files";

export function uploadRFQFiles(formData: FormData) {
    // return request<any>(`${serviceUri}/addrfqfiles`, "POST", { Accept: "application/json" }, formData);
    return request<any>(`${serviceUri}/addrfqfilesv2`, "POST", { Accept: "application/json" }, formData);
}

export function uploadOrderFiles(formData: FormData) {
    return request<any>(`${serviceUri}/uploadFileToCustomPropertyV2`, "POST", { Accept: "application/json" }, formData);
}
